import TimelineActivity from '~/components/drawers/timeline/activity';

class TimelineActivityMerge extends TimelineActivity {}

TimelineActivityMerge.defaultProps = {
  title: (object) => {
    const {
      parameters: {
        name, company, emails, agent_ids,
      },
    } = object.props.activity;
    const options  = [];
    const company_title = _lodash.isEmpty(company) ? '' : `with ${company}`;
    const emailAdresses = _lodash.isEmpty(emails) ? null : options.unshift(`Email addresses: ${emails}`);
    const agentIds      = _lodash.isEmpty(agent_ids) ? null : options.unshift(`Agent IDs: ${agent_ids}`);
    const agentIdAndEmailTitle = _lodash.isEmpty(options) ? '' : `(${options.map((option) => option)})`;

    return (
      `${name} ${agentIdAndEmailTitle} ${company_title} was merged into this record`
    );
  },
  icon:           'compress',
  prefix:         'fas',
  alwaysPublic:   false,
};

export default TimelineActivityMerge;
